const host = process.env.REACT_APP_URL

const posttokopediaCrackScreenUrl = ({ id }) => {
  return `${host}api/v1/policy/${id}/crack-screen-endorse-policy/`
}

export default {
  posttokopediaCrackScreenUrl: posttokopediaCrackScreenUrl
}
